/**
 * Opens a document's blob URL in a new tab (download).
 *
 * Deliberately `window.open` instead of a blob XHR (`axiosInstance` responseType blob):
 * the documents sit as Azure blobs with a SAS token; an XHR download triggers a
 * CORS preflight (OPTIONS → 403). Top-level navigation avoids that — same approach
 * as in the File module (`FileModuleDialog.handleOpen`). The filename on save then
 * depends on the Content-Disposition/blob name, not on the `filename` known here.
 */
export function downloadDocument(blobPath: string | null | undefined) {
  if (!blobPath) return
  window.open(blobPath, '_blank', 'noopener,noreferrer')
}
